import { IShopWholesaler } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { getOnboardingWholesalers } from 'app/auth/state/actions'
import { useDispatch, useSelector } from 'react-redux'

export const getOnboardingWholesalersCacheKey = (filterAvailableForPortal: boolean) => [
  'ONBOARDING',
  'PUBLIC_WHOLESALERS',
  filterAvailableForPortal
]

const useGetUnfilteredOnboardingWholesalers = () => {
  const hasToken = useSelector(state => !!state.auth.tokens.IdToken)
  const dispatch = useDispatch()
  // this hook can't useOnboardingContext it's used while building the context itself
  const filterAvailableForPortal = false

  return useQuery<IShopWholesaler[], unknown>(
    getOnboardingWholesalersCacheKey(filterAvailableForPortal),
    async () => {
      const { Data } = await dispatch(getOnboardingWholesalers(filterAvailableForPortal))
      return Data ?? []
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      enabled: hasToken
    }
  )
}

export default useGetUnfilteredOnboardingWholesalers
